﻿'use strict';

angular.module('ntmApp').factory('CalendarFilterDependencies', ['FormService', function (FormService) {

    function CalendarFilterDependencies() {

        var self = this;

        var dependentColumnCondition = new Map();
        var calendarFilters = [];
        
        self.init = function (filters) {
            calendarFilters = filters;
            filters.forEach(function (filter) {

                if (filter.properties) {
                    filter.properties = JSON.parse(filter.properties);

                    if (filter.properties.dependent) {
                        dependentColumnCondition.set(filter.id, filter.properties.dependent);
                        processDependentFilters(filter, true);
                    }
                }

            });
        };

        self.hasDependentFilters = function (id) {
            return dependentColumnCondition.get(id) !== null;
        };

        self.getDependentData = function (filter) {

            if (!filter.value || filter.value.length === 0) {
                if (filter.selectedFieldType.properties && filter.selectedFieldType.properties.dependent) {
                    processDependentFilters(filter.selectedFieldType, true);
                }
                return;
            }

            var request = {};
            var conditions = dependentColumnCondition.get(filter.selectedFieldType.id) || [];

            conditions.forEach(function (condition) {
                request.id = condition.attributeId;
                request.values = [{
                    field: filter.selectedFieldType.fieldName,
                    value: filter.value.id,
                    operator: condition.operator || '='
                }];

                FormService.Picklist(request).then(function (result) {
                    processDependentFilters(filter.selectedFieldType, false, result.data);
                });
            });            
        };

        function processDependentFilters(filter, val, data) {
            calendarFilters.forEach(function (item) {
                filter.properties.dependent.forEach(function (depFilter) {
                    if (depFilter.attributeId === item.id) {
                        item.hasDependencies = val;

                        if (data) {
                            item.values = data.map(function (val) {
                                return {
                                    id: val[item.fieldName],
                                    value: val[item.fieldName]
                                };
                            });
                        }
                    }
                });
            });
        }

    }

    return (CalendarFilterDependencies);

}]);